import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { lenderAchInformationArr } from "./LenderAchConstants";
import { toast } from "react-toastify";
import { commonToast } from "../../../Utils";
import { LiHandleButton } from "../../../Utils/CustomComponent";
import { Button } from "react-bootstrap";
import FormBox from "../../../components/FormBox/FormBox";
import axios from "../../../axios";
import urls from "../../../Utils/urls";
import { useParams } from "react-router-dom";
import CustomBreadCrumbs from "../../../components/CustomBreadCrumbs";
import MultipleFormBoxComp from "../../../components/FormBox/MultipleFormBoxComp";
import { useAbortController } from "../../../hooks/useAbortController";
import { LenderACHInformationFormOptions } from "../../../Utils/formOptions";
import { oracleConfig } from "../../../Utils/constant";

const LenderACHInformation = () => {
  const { type, jsonId } = useParams();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm(LenderACHInformationFormOptions, { mode: "onBlur" });
  const [activeTab, setActiveTab] = useState(0);
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          urls.dashboard.getLenderOnboard(
            `${localStorage.getItem("email_for_forgot_password")}` +
              "/" +
              jsonId
          ),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
            },
          },
          { signal }
        );
        if (res) {
          let data = res.data.items;
          if (data.length) {
            const parsedData = JSON.parse(data[0].json_data);
            Object.keys(parsedData.ach)?.forEach((key) => {
              setValue(key, parsedData.ach[key]);
            });
            Object.keys(parsedData.details)?.forEach((key) => {
              setValue(key, parsedData.details[key]);
            });
            Object.keys(parsedData.general)?.forEach((key) => {
              setValue(key, parsedData.general[key]);
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    jsonId && fetchData();
  }, [setValue, jsonId]);
  const onSubmit = async (data) => {
    const id = toast.loading("Form Submission Pending");

    try {
      const finalData = {
        OPERATION: "Create",
        USERNAME: userDetails.username,
        JSON_ID: "",
        general: data,
      };
      const res = await axios.post(
        urls.dashboard.postLenderOnboard(),
        finalData,
        oracleConfig
      );
      if (res.status === 200 || res.statusText === "OK") {
        toast.update(id, {
          render: "Form Submitted Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        reset();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className="rounded pb-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Lender Onboarding", link: "/lender-onboard" },
            { title: `${type} Form` },
          ]}
        />

        <article className="container-fluid mt-5">
          <section className="bg-white p-5 my-2 mx-4">
            <h4 className="mt-5">New Lender Onboarding</h4>
            <div className="loan-details">
              <div className="pt-5 mt-5">
                <ul className="nav nav-tabs">
                  {tabButtons.map((data, index) => (
                    <LiHandleButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                      handleBtnClick={setActiveTab}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {lenderAchInformationArr.map(
                  (data, index) =>
                    activeTab === index && (
                      <MultipleFormBoxComp
                        key={index}
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        options={data.arr}
                        errors={errors}
                      />
                    )
                )}
                <div className="col-sm-12 d-flex justify-content-end">
                  {/* {activeTab > 0 && (
                    <Button
                      onClick={() => setActiveTab(activeTab - 1)}
                      className="me-2"
                    >
                      Back
                    </Button>
                  )}
                  {activeTab < 2 && (
                    <Button
                      onClick={() => setActiveTab(activeTab + 1)}
                      className="me-2"
                    >
                      Next
                    </Button>
                  )} */}
                  {/* {activeTab === 2 && ( */}
                  <Button type="submit" className="me-2 mt-3 text-white">
                    Submit
                  </Button>
                  {/* )} */}
                </div>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};

export default LenderACHInformation;

const tabButtons = [
  { label: <p>General</p> },
  // { label: <p>Details</p> },
  // { label: <p>ACH</p> },
];
